import type { OnInit } from '@angular/core';
import { Component, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { TT_ASSETS_ENDPOINT, GoogleAnalyticsService } from '@candyland/angular/shared/util-nmo';
// eslint-disable-next-line @nx/enforce-module-boundaries
import type { TtComVideo, TtComVideoPlaylist } from '@candyland/generic/tt-com-shared-overviews';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {
  defaultVideo: TtComVideo;
  videoGroups: TtComVideo[][];

  constructor(
    private http: HttpClient,
    private gaService: GoogleAnalyticsService,
    private router: Router,
    @Inject(TT_ASSETS_ENDPOINT) private readonly assetsEndpoint: string
  ) {}

  ngOnInit(): void {
    this.http.get(`${this.assetsEndpoint}/data/overview_video_playlist.json`).subscribe((data: TtComVideoPlaylist) => {
      this.defaultVideo = data.videos[0];
      this.videoGroups = this.groupVideos(data.videos);
      console.log({ defaultVideo: this.defaultVideo, videoGroups: this.videoGroups });
    });
  }

  trackVideoContainerSlideChange(groupIndex: number): void {
    this.gaService.pushEvent({
      event: 'Videos',
      category: 'Startseite-Video-APA',
      titel: this.videoGroups[groupIndex][0].title,
      url: this.router.routerState.snapshot.url,
    });
  }

  private groupVideos(array: TtComVideo[]): TtComVideo[][] {
    const groupedVideos: TtComVideo[][] = [];
    let group: TtComVideo[];
    for (let i = 0; i < array.length; i++) {
      if (!(i % 3)) {
        groupedVideos.push((group = []));
      }
      group.push(array[i]);
    }
    return groupedVideos;
  }
}
